/**
 * Production — path suite (`/erp-apps/`) or subdomain prod (`deployment-prod`).
 * Public-site JSON: `/api/v1/public-site/` on Node → `${apiRoot()}/v1/public-site/`.
 */
const SUITE_PREFIX = '/erp-apps';
const PROD_API_ORIGIN = 'https://api.erp.mootori.com';
const PROD_HOST_ERP = 'https://erp.mootori.com';
const PROD_HOST_GMS = 'https://gms.mootori.com';
const PROD_HOST_ACC = 'https://accounting.mootori.com';
const PROD_HOST_ADMIN = 'https://admin.mootori.com';
const PROD_HOST_MOOTORI = 'https://mootori.com';

function prodHostname(): string {
  try {
    return typeof window !== 'undefined' && window.location?.hostname ? window.location.hostname : '';
  } catch {
    return '';
  }
}

function useMootoriProductionHosts(): boolean {
  const h = prodHostname();
  return (
    h === 'mootori.com' ||
    h === 'www.mootori.com' ||
    (h.endsWith('.mootori.com') && h !== 'api.erp.mootori.com')
  );
}

function apiRoot(): string {
  return useMootoriProductionHosts() ? PROD_API_ORIGIN : `${SUITE_PREFIX}/api`;
}

function spaOrigin(): string {
  try {
    if (typeof document !== 'undefined' && document.baseURI) {
      return new URL(document.baseURI).origin;
    }
  } catch {
    /* ignore */
  }
  if (typeof globalThis !== 'undefined') {
    const g = globalThis as unknown as { location?: { origin?: string } };
    if (g.location?.origin) {
      return g.location.origin;
    }
  }
  return 'http://34.239.215.141';
}

export const environment = {
  production: true,
  get APIURL() {
    return `${apiRoot()}/v1/public-site/`;
  },
  APIKEY: '63548b0034c2486696b2898a030865b2989b3c0201272163494b533860801493',
  get erpPortalUrl() {
    return useMootoriProductionHosts() ? PROD_HOST_ERP : `${spaOrigin()}${SUITE_PREFIX}/erp`;
  },
  get portalSelfUrl() {
    return useMootoriProductionHosts() ? PROD_HOST_MOOTORI : `${spaOrigin()}${SUITE_PREFIX}/mootori`;
  },
  get gmsUrl() {
    return useMootoriProductionHosts() ? PROD_HOST_GMS : `${spaOrigin()}${SUITE_PREFIX}/gms`;
  },
  get accUrl() {
    return useMootoriProductionHosts() ? PROD_HOST_ACC : `${spaOrigin()}${SUITE_PREFIX}/acc`;
  },
  get adminUrl() {
    return useMootoriProductionHosts() ? PROD_HOST_ADMIN : `${spaOrigin()}${SUITE_PREFIX}/admin`;
  },
  get authUrl() {
    return `${apiRoot()}/auth`;
  },
  USERSFILESURL: 'https://mootori-s3-bucket-v2.s3.amazonaws.com/usersfiles',
  FILESURL: 'https://mootori-s3-bucket-v2.s3.amazonaws.com/appfiles'
};
